import type { Step } from "react-joyride";

export const meetingListTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ສະແດງລາຍການບັນທຶກການປະຊຸມ. ທ່ານສາມາດກັ່ນຕອງຕາມວັນທີ, ຄົ້ນຫາ, ເພີ່ມບັນທຶກໃໝ່ ຫຼື ເບິ່ງ/ແກ້ໄຂ/ລຶບ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="meeting-list-header"]',
    content:
      "ຫົວຂໍ້ບັນທຶກການປະຊຸມ. ກົດ 'ເພີ່ມບັນທຶກປະຊຸມ' ເພື່ອສ້າງໃໝ່. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="meeting-list-filter"]',
    content:
      "ເລືອກຊ່ວງວັນທີ ແລະ ຄົ້ນຫາເພື່ອກັ່ນຕອງລາຍການບັນທຶກການປະຊຸມ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="meeting-list-table"]',
    content:
      "ຕາຕະລາງບັນທຶກການປະຊຸມ. ກົດແຖບເພື່ອເບິ່ງລາຍລະອຽດ, ແກ້ໄຂ, ເບິ່ງ PDF ຫຼື ປະເດັນທີ່ລົມກັນ.",
    placement: "top",
  },
];
